/**
 * Close unclosed markdown constructs in streaming text to prevent
 * rendering glitches while the response is still being generated.
 */
export function sanitizeStreamingMarkdown(text: string, isStreaming: boolean): string {
    if (!isStreaming) return text;

    let result = text;

    const fenceCount = (result.match(/```/g) || []).length;
    if (fenceCount % 2 !== 0) {
        result += '\n```';
    }

    const boldCount = (result.match(/\*\*/g) || []).length;
    if (boldCount % 2 !== 0) {
        result += '**';
    }

    const italicMatches = result.match(/(?<!\*)\*(?!\*)/g) || [];
    if (italicMatches.length % 2 !== 0) {
        result += '*';
    }

    const backtickMatches = result.match(/(?<!`)`(?!`)/g) || [];
    if (backtickMatches.length % 2 !== 0) {
        result += '`';
    }

    return result;
}
